module.exports = __webpack_public_path__ + "img/search-hero-overflow-lincoln.e402e159.png";